module.exports = __webpack_public_path__ + "static/media/sound3.c88b6de9.mp3";